import script from "./unpaid-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./unpaid-modal.vue?vue&type=script&setup=true&lang=js"

import "./unpaid-modal.vue?vue&type=style&index=0&id=362c5f7c&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-362c5f7c"]])

export default __exports__